module.exports = "/images/search.svg?b98419b58496ca950d3649c269a90a54";